import { Form } from "antd";
import ReactQuill from "react-quill";
import "./TextFormat.scss"

function TextFormat() {
  const modules = {
    toolbar: {
      container: [
        [{ header: "1" }, { header: "2" }, { font: [] }],
        [{ size: [] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["link", "image", "video"],
        ["clean"],
      ],
    },
  };
  return (
    <>
      <Form.Item
        name="description"
        label="Description"
        rules={[
          {
            required: true,
            message: "please enter url description",
          },
        ]}>
        <ReactQuill
          style={{ height: 350 }}
          theme="snow"
          // value={description}
          // onChange={setDescription} // Cập nhật 'description' khi người dùng thay đổi
          modules={modules}
          formats={[
            "header",
            "bold",
            "italic",
            "underline",
            "strike",
            "link",
            "list",
            "bullet",
            "image",
          ]}
        />
      </Form.Item>
    </>
  );
}

export default TextFormat;
